import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@rsos/components/capstone/base';
import { CONVERSATION_ENDED } from '@rsos/constants/chatStatuses';
import {
  deleteConversation,
  fetchAlertConversationStatus,
} from '@rsos/reduxDataStore/src/features/alerts/chatSlice';
import { PRIVILEGED_CHAT_MARGIN } from '../AlertChatBox/AlertChatBox.styles';
import PrivilegedChatHeader from '../PrivilegedChatHeader';
import AlertPrivilegedChatbox from './AlertPrivilegedChatbox';

const PrivilegedChat = ({
  chatRef,
  isChatBoxVisible,
  unreadAmount,
  privilegedConversation,
  onActionButtonClick,
  handleShowDeclinePane,
  bottomPaneHeight,
  isUnread,
}) => {
  const dispatch = useDispatch();
  const currentOrgName = useSelector(
    state => state.sinatra.user.currentOrg.name,
  );

  const handleEndChat = () => {
    dispatch(
      deleteConversation({
        orgName: currentOrgName,
        conversationID: privilegedConversation.id,
      }),
    );
  };

  useEffect(() => {
    dispatch(
      fetchAlertConversationStatus({
        orgName: currentOrgName,
        conversationID: privilegedConversation.id,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      mb={PRIVILEGED_CHAT_MARGIN}
      ref={chatRef}
      grow={isChatBoxVisible}
      border={unreadAmount > 0 && '1px solid'}
      borderColor={unreadAmount > 0 && 'lightDanger'}
      borderRadius={'5px'}
    >
      <PrivilegedChatHeader
        alertChatParticipants={privilegedConversation.participants}
        isChatBoxVisible={isChatBoxVisible}
        isUnread={isUnread}
        onActionButtonClick={onActionButtonClick}
        hasChatEnded={
          privilegedConversation?.status === CONVERSATION_ENDED ||
          !privilegedConversation?.status
        }
        onEndChat={handleEndChat}
        unreadAmount={unreadAmount}
      />
      <AlertPrivilegedChatbox
        chatBoxHeight={bottomPaneHeight}
        isChatBoxVisible={isChatBoxVisible}
        onShowDeclinePane={handleShowDeclinePane}
        hasChatEnded={privilegedConversation?.status === CONVERSATION_ENDED}
      />
    </Box>
  );
};

export default PrivilegedChat;
